import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
import Logger from "../../../basecomp/base/Logger";
import axios from "axios";

// Base Url Setup
const { axiosGetCall, axiosGetCallHeader } = AxiosWrapper;
const REACT_BE_URL = process.env.REACT_APP_BE_URL;

// ========================================
// EXISTING FUNCTIONS (UNCHANGED)
// ========================================

// Continent API Call
const fetchContinentData = async () => {
  try {
    const response = await axiosGetCall(`/gln/getUniqueContinentCodes`);
    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching data:", error);
    throw error;
  }
};

// Country API Call
const fetchCountryData = async () => {
  try {
    const response = await axiosGetCall(`/gln/getUniqueCountryCodes`);
    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching data:", error);
    throw error;
  }
};

// Region API Call
const fetchRegionData = async (searchInput, selectedCountryCodes) => {
  try {
    const response = await axiosGetCall(
      `/gln/searchRegionCodes?` +
        `countryCodes=${selectedCountryCodes}&searchInput=${searchInput}`
    );
    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching data:", error);
    throw error;
  }
};

// City API Call
const fetchCityData = async (
  searchInput,
  selectedRegionCodes,
  selectedCountryCodes
) => {
  try {
    const response = await axiosGetCall(
      `/gln/searchCityCodes?` +
        `regionCodes=${selectedRegionCodes}&countryCodes=${selectedCountryCodes}&searchInput=${searchInput}`
    );
    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching data:", error);
    throw error;
  }
};

// City Facility Call
const fetchFacilityData = async (
  searchInput,
  selectedCityCodes,
  selectedCountryCodes,
  codeType,
  selectedRegionCodes
) => {
  try {
    const response = await axiosGetCall(
      `/gln/searchFacilityCodes?` +
        `cityCodes=${selectedCityCodes}&regionCodes=${selectedRegionCodes}&countryCodes=${selectedCountryCodes}&searchInput=${searchInput}&codeType=${codeType}`
    );
    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching data:", error);
    throw error;
  }
};

const fetchGlnData = async (
  cityCodes,
  facilityCodes,
  glnId,
  facilityName,
  allFilter
) => {
  try {
    const response = await axiosGetCall(
      `/gln/getGlnData?` +
        `cityCodes=${cityCodes}&facilityCodes=${facilityCodes}&glnId=${glnId}&facilityName=${facilityName}&allFilter=${allFilter}`
    );
    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching data:", error);
    throw error;
  }
};

// ========================================
// USER MANAGEMENT FUNCTIONS
// ========================================

/**
 * Get user profile information
 * @param {string} email - User email
 * @returns {Promise} API response with user profile
 */
const getUserProfile = async (email) => {
  try {
    console.log("🌐 Fetching profile for user:", email);
    
    const response = await axiosGetCall(`/gln/getUserProfile?email=${encodeURIComponent(email)}`);
    console.log("📡 Profile response:", response.data);
    
    if (response.status === 200) {
      const apiResponse = response.data;
      
      if (apiResponse.success && apiResponse.data) {
        console.log("✅ Profile fetched successfully");
        return apiResponse;
      } else {
        throw new Error(apiResponse.message || "API returned success: false");
      }
    } else {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    console.error("❌ getUserProfile error:", error);
    throw error;
  }
};

/**
 * Get user's permissions
 * @param {string} email - User email
 * @returns {Promise} API response with user permissions
 */
const getUserPermissions = async (email) => {
  try {
    console.log("🌐 Fetching permissions for user:", email);
    
    const response = await axiosGetCall(`/gln/getUserPermissions?email=${encodeURIComponent(email)}`);
    console.log("📡 Permissions response:", response.data);
    
    if (response.status === 200) {
      const apiResponse = response.data;
      
      if (apiResponse.success && apiResponse.data) {
        console.log("✅ Permissions fetched successfully");
        return apiResponse;
      } else {
        throw new Error(apiResponse.message || "API returned success: false");
      }
    } else {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    console.error("❌ getUserPermissions error:", error);
    
    // Return a fallback response for permissions if API fails
    console.log("⚠️ Permissions API failed, using fallback empty permissions");
    return {
      success: true,
      data: [] // Empty permissions array
    };
  }
};

/**
 * Get user's GLN records with permissions filtering
 * @param {string} email - User email
 * @param {number} page - Page number for pagination
 * @param {number} limit - Records per page
 * @returns {Promise} API response with user's GLN records
 */
const getUserGlnRecords = async (email, page = 1, limit = 10) => {
  try {
    console.log("🌐 Fetching GLN records for user:", email);
    
    const response = await axiosGetCall(
      `/gln/getUserGlnRecords?email=${encodeURIComponent(email)}&page=${page}&limit=${limit}`
    );
    console.log("📡 GLN records response:", response.data);
    
    if (response.status === 200) {
      const apiResponse = response.data;
      
      if (apiResponse.success && apiResponse.data) {
        console.log("✅ GLN records fetched successfully");
        console.log("📊 Records count:", apiResponse.data.records?.length || 0);
        return apiResponse;
      } else {
        throw new Error(apiResponse.message || "API returned success: false");
      }
    } else {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    console.error("❌ getUserGlnRecords error:", error);
    
    // Return a fallback response for GLN records if API fails
    console.log("⚠️ GLN Records API failed, using fallback empty records");
    return {
      success: true,
      data: {
        user: null,
        permissions: [],
        records: [],
        totalRecords: 0,
        recordsByCategory: {
          myCompanyRecords: 0,
          createdByMe: 0,
          bicFacilities: 0,
          unlocodePorts: 0,
          others: 0
        },
        lastUpdated: null
      }
    };
  }
};

// ========================================
// CRUD OPERATIONS FOR GLN RECORDS (UPDATED)
// ========================================

/**
 * Add a new GLN record
 * @param {Object} recordData - GLN record data
 * @returns {Promise} API response
 */
const addGlnRecord = async (recordData) => {
  try {
    Logger.info("Adding new GLN record:", recordData);
    
    const response = await axios.post(
      `${REACT_BE_URL}/gln/addGlnRecord`,
      recordData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response.status === 201) {
      if (response.data.success) {
        Logger.info("GLN record added successfully:", response.data);
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error adding GLN record:", error);
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error("Failed to add GLN record. Please try again.");
  }
};

/**
 * Get GLN record by ID
 * @param {string} recordId - GLN record ID
 * @returns {Promise} API response with GLN record details
 */
const getGlnRecordById = async (recordId) => {
  try {
    Logger.info("Fetching GLN record details:", recordId);
    
    const response = await axiosGetCall(`/gln/getGlnRecord/${recordId}`);
    
    if (response.status === 200) {
      if (response.data.success) {
        Logger.info("GLN details fetched successfully:", response.data);
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error fetching GLN record details:", error);
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error("Failed to fetch GLN record details. Please try again.");
  }
};

/**
 * Update GLN record
 * @param {string} recordId - GLN record ID to update
 * @param {Object} updateData - Data to update
 * @returns {Promise} API response
 */
const updateGlnRecord = async (recordId, updateData) => {
  try {
    console.log("Updating GLN record:", recordId, updateData);    
    const response = await axios.put(
      `${REACT_BE_URL}/gln/updateGlnRecord/${recordId}`,
      updateData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Full axios response:", response);
    console.log("Response data:", response.data);
    console.log("Response status:", response.status);
    console.log("Response data success:", response.data.success);
    
    if (response.status === 200) {
      if (response.data.success) {
        console.log("✅ SUCCESS: Returning success response");
        console.log("GLN record updated successfully:", response.data);
        return response.data;
      } else {
        console.log("❌ FAIL: response.data.success is false");
        throw new Error(response.data.message || "Update failed");
      }
    } else {
      console.log("❌ FAIL: Non-200 status code:", response.status);
      throw new Error("Non-200 response status");
    }
  } catch (error) {
    console.log("❌ CATCH: Error caught:", error);
    console.error("Error updating GLN record:", error);
    
    if (error.response?.data?.message) {
      console.log("❌ Throwing API error message:", error.response.data.message);
      throw new Error(error.response.data.message);
    }
    
    console.log("❌ Throwing generic error message");
    throw new Error("Failed to update GLN record. Please try again.");
  }
};

/**
 * UPDATED: Deactivate GLN record (instead of delete)
 * @param {string} recordId - GLN record ID to deactivate
 * @returns {Promise} API response
 */
const deactivateGlnRecord = async (recordId) => {
  try {
    console.log("🔴 Frontend: Deactivating GLN record:", recordId);
    console.log("🔴 URL:", `${REACT_BE_URL}/gln/deactivateGlnRecord/${recordId}`);
    
    const response = await axios.put(
      `${REACT_BE_URL}/gln/deactivateGlnRecord/${recordId}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    console.log("🔴 Frontend: Deactivate response received:", response.data);
    console.log("🔴 Frontend: Success status:", response.data.success);
    
    return response.data;
    
  } catch (error) {
    console.error("🔴 Frontend: Error in deactivateGlnRecord:", error);
    console.error("🔴 Frontend: Error response:", error.response?.data);
    
    if (error.response?.data) {
      throw new Error(error.response.data.message || "Failed to deactivate record");
    }
    
    throw new Error(error.message || "Failed to deactivate record");
  }
};

/**
 * Search GLN records with filters
 * @param {Object} searchParams - Search parameters
 * @returns {Promise} API response with search results
 */
const searchGlnRecords = async (searchParams) => {
  try {
    Logger.info("Searching GLN records:", searchParams);
    
    const queryParams = new URLSearchParams(searchParams).toString();
    const response = await axiosGetCall(`/gln/searchGlnRecords?${queryParams}`);
    
    if (response.status === 200) {
      if (response.data.success) {
        Logger.info("GLN records search completed:", response.data);
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error searching GLN records:", error);
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error("Failed to search GLN records. Please try again.");
  }
};

/**
 * Validate GLN code format and uniqueness
 * @param {Object} codeData - Code data to validate
 * @returns {Promise} API response with validation results
 */
const validateGlnCode = async (codeData) => {
  try {
    Logger.info("Validating GLN code:", codeData);
    
    const response = await axios.post(
      `${REACT_BE_URL}/gln/validateGlnCode`,
      codeData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response.status === 200) {
      if (response.data.success) {
        Logger.info("GLN code validation completed:", response.data);
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error validating GLN code:", error);
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error("Failed to validate GLN code. Please try again.");
  }
};

// ========================================
// UNIFIED EXPORT FUNCTIONALITY
// ========================================

/**
 * Unified export function for user's GLN records
 * Handles both individual record and table exports
 * @param {string} email - User email
 * @param {Object} exportParams - Export parameters (filters, sorting, type, etc.)
 * @returns {Promise} API response that triggers download
 */
/**
 * Unified export function for user's GLN records
 * Handles both individual record and table exports
 * @param {string} email - User email
 * @param {Object} exportParams - Export parameters (filters, sorting, type, etc.)
 * @returns {Promise} Success response or throws error
 */
/**
 * Simplified export function for user's GLN records
 * Exports specific records by their IDs (what's currently displayed/filtered)
 * @param {string} email - User email
 * @param {Object} exportParams - Export parameters with recordIds
 * @returns {Promise} Success response or throws error
 */
const exportUserGlnRecords = async (email, exportParams) => {
  try {
    console.log("Exporting GLN records for user:", email);
    console.log("Export params:", exportParams);
    
    // Validate required parameters
    if (!email) {
      throw new Error("User email is required for export");
    }

    // Build query parameters based on export type
    const queryParams = new URLSearchParams();
    queryParams.append('email', email);
    queryParams.append('exportType', exportParams.exportType || 'filtered');

    // Handle different export types
    if (exportParams.exportType === 'single' || exportParams.exportType === 'selected') {
      // For single or selected exports, recordIds are required
      if (!exportParams.recordIds) {
        throw new Error("No records specified for export");
      }
      queryParams.append('recordIds', exportParams.recordIds);
    } else {
      // For filtered/table export, use category and search filters
      if (exportParams.category) {
        queryParams.append('category', exportParams.category);
      }
      if (exportParams.searchQuery) {
        queryParams.append('searchQuery', exportParams.searchQuery);
      }
    }

    // Add optional sorting parameters for all export types
    if (exportParams.sortBy) {
      queryParams.append('sortBy', exportParams.sortBy);
    }
    if (exportParams.sortDirection) {
      queryParams.append('sortDirection', exportParams.sortDirection);
    }

    const queryString = queryParams.toString();
    console.log("Query string:", queryString);

    // Make the API request
    const response = await axios.get(
      `${REACT_BE_URL}/gln/exportGlnRecords?${queryString}`,
      {
        responseType: "blob",
        timeout: 300000, // 5-minute timeout for large exports
        headers: {
          'Accept': 'text/csv, application/json',
        },
      }
    );

    console.log("Response received:", {
      status: response.status,
      contentType: response.headers['content-type'],
      size: response.data.size
    });

    // Check if the response is actually an error in JSON format
    if (response.data.type && response.data.type.includes('application/json')) {
      console.log("Received JSON error response as blob");
      try {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || 'Export failed - server returned error');
      } catch (parseError) {
        console.error("Error parsing JSON error response:", parseError);
        throw new Error('Export failed - invalid server response');
      }
    }

    // Validate that we received CSV data
    if (response.data.size === 0) {
      throw new Error('Export failed - received empty file');
    }

    // Create a URL for the blob and trigger download
    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Generate filename based on export context
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    
    let filename;
    if (exportParams.exportType === 'single') {
      filename = `gln_record_${exportParams.recordIds}_${timestamp}.csv`;
    } else if (exportParams.exportType === 'selected') {
      const recordCount = exportParams.recordIds.split(',').length;
      filename = `selected_gln_records_${recordCount}_${timestamp}.csv`;
    } else {
      // Filtered/table export
      const categoryPart = exportParams.category && exportParams.category !== 'all' 
        ? `_${exportParams.category}` : '';
      const searchPart = exportParams.searchQuery ? '_filtered' : '';
      filename = `gln_records${categoryPart}${searchPart}_${timestamp}.csv`;
    }

    link.download = filename;

    // Append link to body, click it, then remove it
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    console.log("Export completed successfully:", filename);

    return {
      success: true,
      message: "GLN records exported successfully",
      filename: filename
    };

  } catch (error) {
    console.error("Export error:", error);
    
    // Enhanced error handling
    if (error.response) {
      console.log("Error response details:", {
        status: error.response.status,
        statusText: error.response.statusText,
        contentType: error.response.headers['content-type']
      });

      // Handle blob error responses (when server sends JSON error as blob)
      if (error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          console.log("Blob error content:", text);
          
          // Try to parse as JSON
          try {
            const errorData = JSON.parse(text);
            throw new Error(errorData.message || `Export failed: ${errorData.error || 'Unknown error'}`);
          } catch (jsonError) {
            // If it's not JSON, just use the text
            throw new Error(text || `Export failed with status ${error.response.status}`);
          }
        } catch (blobError) {
          console.error("Error reading blob:", blobError);
          throw new Error(`Export failed with status ${error.response.status}`);
        }
      }
      
      // Handle regular JSON error responses
      else if (error.response.data?.message) {
        throw new Error(error.response.data.message);
      }
      
      // Handle HTTP error statuses
      else {
        const statusMessages = {
          400: 'Bad request - please check your export parameters',
          401: 'Unauthorized - please log in again',
          403: 'Forbidden - you do not have permission to export these records',
          404: 'No records found to export',
          500: 'Server error - please try again later'
        };
        
        const message = statusMessages[error.response.status] || 
          `Export failed with status ${error.response.status}`;
        throw new Error(message);
      }
    }
    
    // Handle network/timeout errors
    else if (error.code === 'ECONNABORTED') {
      throw new Error('Export timeout - the request took too long. Please try with fewer records or contact support.');
    }
    else if (error.message?.includes('Network Error')) {
      throw new Error('Network error - please check your connection and try again.');
    }
    
    // Re-throw the original error if it's already a custom message
    throw new Error(error.message || "Failed to export GLN records. Please try again.");
  }
};

// ========================================
// BULK OPERATIONS (UPDATED)
// ========================================

/**
 * Bulk add GLN records
 * @param {Array} records - Array of GLN records to add
 * @returns {Promise} API response
 */
const bulkAddGlnRecords = async (records) => {
  try {
    Logger.info("Bulk adding GLN records:", records.length, "records");
    
    const response = await axios.post(
      `${REACT_BE_URL}/gln/bulkAddGlnRecords`,
      { records },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response.status === 201) {
      if (response.data.success) {
        Logger.info("GLN records bulk added successfully:", response.data);
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error bulk adding GLN records:", error);
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error("Failed to bulk add GLN records. Please try again.");
  }
};

/**
 * Bulk update GLN records
 * @param {Array} updates - Array of updates {recordId, data}
 * @returns {Promise} API response
 */
const bulkUpdateGlnRecords = async (updates) => {
  try {
    Logger.info("Bulk updating GLN records:", updates.length, "records");
    
    const response = await axios.post(
      `${REACT_BE_URL}/gln/bulkUpdateGlnRecords`,
      { updates },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response.status === 200) {
      if (response.data.success) {
        Logger.info("GLN records bulk updated successfully:", response.data);
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error bulk updating GLN records:", error);
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error("Failed to bulk update GLN records. Please try again.");
  }
};

/**
 * UPDATED: Bulk deactivate GLN records (instead of delete)
 * @param {Array} recordIds - Array of GLN record IDs to deactivate
 * @returns {Promise} API response
 */
const bulkDeactivateGlnRecords = async (recordIds) => {
  try {
    Logger.info("Bulk deactivating GLN records:", recordIds.length, "records");
    
    const response = await axios.post(
      `${REACT_BE_URL}/gln/bulkDeactivateGlnRecords`,
      { recordIds },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response.status === 200) {
      if (response.data.success) {
        Logger.info("GLN records bulk deactivated successfully:", response.data);
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error bulk deactivating GLN records:", error);
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error("Failed to bulk deactivate GLN records. Please try again.");
  }
};

// ========================================
// EXISTING FILE PROCESSING FUNCTIONS
// ========================================

const processUnlocodeFile = async (formData) => {
  try {
    const response = await axios.post(
      `${REACT_BE_URL}/gln/processUnlocodeFile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error processing UNLOCODE file:", error);
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Error processing UNLOCODE file");
  }
};

const processImoFile = async (formData) => {
  try {
    const response = await axios.post(
      `${REACT_BE_URL}/gln/processImoFile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      if (response.data.status === undefined || response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    }
  } catch (error) {
    Logger.printStackTrace("Error processing IMO file:", error);
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Error processing IMO file");
  }
};

const processSubregionFile = async (formData) => {
  try {
    const response = await axios.post(
      `${REACT_BE_URL}/gln/processSubregionFile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("response", response);

    // Check for success response - the API returns "success" in the status field
    if (response.data && response.data.status === "success") {
      return response.data;
    }

    // If we receive a 200 status but the data status is not "success"
    if (response.data && response.data.status !== "success") {
      throw new Error(
        response.data.message || "Unexpected response from server"
      );
    }

    // If we reach here, something unexpected happened but we got a 200 status
    return response.data;
  } catch (error) {
    Logger.printStackTrace("Error processing subregion file:", error);
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Error processing subregion file");
  }
};

const downloadFacilityCodes = async (countryCode = "All") => {
  try {
    // Build the query parameters
    const queryParams = new URLSearchParams();

    // Add country code parameter if provided and not "All"
    if (countryCode && countryCode !== "All") {
      queryParams.append("countryCodes", countryCode);
    }

    // Construct the URL with query parameters
    const url = `${REACT_BE_URL}/gln/exportFacilityCodes?${queryParams.toString()}`;

    console.log(`Sending request to download facility codes: ${url}`);

    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        "Content-Type": "text/csv",
      },
      timeout: 300000, // 5-minute timeout for large exports
    });

    // Create a URL for the blob and trigger download
    const blob = new Blob([response.data], { type: "text/csv" });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Include country code in filename if provided
    const countryPart =
      countryCode && countryCode !== "All" ? `_${countryCode}` : "";
    link.download = `facility_codes${countryPart}.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return {
      success: true,
      type: "facility_codes",
      country: countryCode || "All",
    };
  } catch (error) {
    Logger.printStackTrace("Error downloading facility codes:", error);
    throw error;
  }
};

const downloadGlnTable = async (countryCode = "All") => {
  try {
    // Build the query parameters
    const queryParams = new URLSearchParams();

    // Add country code parameter if provided and not "All"
    if (countryCode && countryCode !== "All") {
      queryParams.append("countryCodes", countryCode);
    }

    // Construct the URL with query parameters
    const url = `${REACT_BE_URL}/gln/exportGlnTable?${queryParams.toString()}`;

    console.log(`Sending request to download GLN table: ${url}`);

    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        "Content-Type": "text/csv",
      },
      timeout: 300000, // 5-minute timeout for large exports
    });

    // Create a URL for the blob and trigger download
    const blob = new Blob([response.data], { type: "text/csv" });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Include country code in filename if provided
    const countryPart =
      countryCode && countryCode !== "All" ? `_${countryCode}` : "";
    link.download = `gln_table_export${countryPart}.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return {
      success: true,
      type: "gln_table",
      country: countryCode || "All",
    };
  } catch (error) {
    Logger.printStackTrace("Error downloading GLN table:", error);
    throw error;
  }
};

// ========================================
// UTILITY FUNCTIONS
// ========================================

export const getDownloadExportFile = async (selectedCodeData) => {
  const queryParams = new URLSearchParams(selectedCodeData).toString();
  console.log("queryParams", queryParams);
  let url = `${REACT_BE_URL}/gln/downloadExportFile?${queryParams}`;

  let response;
  try {
    response = await axiosGetCallWithTokenHeader(url);
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened. If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);
    throw sendError;
  }

  if (response === undefined) {
    throw new Error("No response");
  }

  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const axiosGetCallWithTokenHeader = async (url) => {
  try {
    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/excel",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// For backward compatibility
const downloadBicSmdgData = async (
  exportGlnTable = false,
  countryCode = "All"
) => {
  if (exportGlnTable) {
    return downloadGlnTable(countryCode);
  } else {
    return downloadFacilityCodes(countryCode);
  }
};

// ========================================
// EXPORTS (UPDATED)
// ========================================

export {
  // Existing exports
  fetchContinentData,
  fetchCountryData,
  fetchRegionData,
  fetchCityData,
  fetchFacilityData,
  fetchGlnData,
  processUnlocodeFile,
  processImoFile,
  downloadBicSmdgData,
  downloadFacilityCodes,
  downloadGlnTable,
  processSubregionFile,
  
  // User management exports
  getUserGlnRecords,
  getUserPermissions,
  getUserProfile,
  
  // Updated CRUD exports
  addGlnRecord,
  getGlnRecordById,
  updateGlnRecord,
  deactivateGlnRecord, // Updated from deleteGlnRecord
  searchGlnRecords,
  validateGlnCode,
  
  // Export functionality
  exportUserGlnRecords,
  
  // Updated bulk operations exports
  bulkAddGlnRecords,
  bulkUpdateGlnRecords,
  bulkDeactivateGlnRecords, // Updated from bulkDeleteGlnRecords
};